<template>
    <div>
        <div v-if="isAppIdle"></div>

        <div v-if="!loading && component">
            <component
                :is="component.type.toLowerCase() + '-component'"
                :component="component"
                :enrollment="enrollment"
                :outline="outline"
                :time="lessonTime"
                @saveData="saveData"
                @goto="goToOutline"
                @complete="completeComponent"
            />
        </div>
        <div class="content-frame content pl-5 pt-6" v-else>
            <h4 class="has-text-grey"><i class="fas fa-spinner fa-spin mr-4"></i>Please wait. Loading content...</h4>
        </div>
    </div>
</template>

<script>
    import {v4 as uuidv4} from 'uuid';
    import moment from "moment";
    import async from "async";

    import {client as http} from "@/http_client";
    import RenderEditorJsComponent from "../../components/RenderComponent";


    import LessonComponent from "../../components/course/LessonComponent";
    import QuizComponent from "../../components/course/QuizComponent";
    import SurveyComponent from "../../components/course/SurveyComponent";
    import CheckpointComponent from "../../components/course/CheckpointComponent";
    import {mapGetters} from "vuex";

    export default {
        components: {LessonComponent, QuizComponent, CheckpointComponent, SurveyComponent},
        props: ['enrollmentId', 'outlineId'],
        data: function() {
            return {
                loading: true,
                component: {
                    content: '{}'
                },
                outline: {},
                prevOutlineId: null,
                nextOutlineId: null,
                timer: null,
                time: 0,
                uuid: null,
                timeout: 60
            };
        },
        computed: {
            ...mapGetters(['enrollment']),
            formattedTime: function() {
                return moment.utc(this.time * 1000).format('HH:mm:ss');
            },
            formattedMinTime: function() {
                return moment.utc(this.outline.require_min_time * 60 * 1000).format('HH:mm:ss');
            },
            formattedLessonTime: function() {
                return moment.utc((this.time * 1000) + (this.outline.time * 60 * 1000)).format('HH:mm:ss');
            },
            lessonTime: function() {
                return this.time + (this.outline.time * 60);
            }
        },
        methods: {
            loadByOutline: function() {
                if (this.timer) clearInterval(this.timer);
                this.time = 0;
                this.uuid = uuidv4();
                this.loading = true;
                this.timeout = 60;
                this.outline = {};

                async.series([
                    (cb) => {
                        let prevOutlineId;
                        let count = 0;

                        sectionLoop:
                            for (let i = 0; i < this.enrollment.course.outline.length; i++) {
                                let section = this.enrollment.course.outline[i];

                                for (let j = 0; j < section.components.length; j++) {
                                    count++;
                                    const component = section.components[j];

                                    if (component.component_id === parseInt(this.outlineId)) {
                                        this.outline = {...component, prevOutlineId, nextOutlineId: null, nextSectionId: null};
                                        this.outline.counts = {
                                            ofSection: (j + 1),
                                            totalSection: section.components.length,
                                            ofTotal: count
                                        };
                                        this.outline.section = section;
                                        this.outline.nextOutlineId = (section.components[j + 1]) ? section.components[j + 1].component_id : null;

                                        if (!this.outline.nextOutlineId) { // lets look to the next section still
                                            if (this.enrollment.course.outline[i + 1]) {
                                                if (this.enrollment.course.outline[i + 1].description) {
                                                    this.outline.nextSectionId = this.enrollment.course.outline[i + 1].type_id;
                                                }
                                                this.outline.nextOutlineId = (this.enrollment.course.outline[i + 1].components[0]) ? this.enrollment.course.outline[i + 1].components[0].component_id : null;
                                            }
                                        }

                                        break sectionLoop;
                                    } else {
                                        prevOutlineId = component.component_id;
                                    }
                                }
                            }

                        // new min time injected into legacy
                        let content = JSON.parse(this.outline.content, this.outline.require_min_time);
                        if (content && content.attributes && content.attributes.minTimeToggle && parseInt(content.attributes.minTime)) {
                            this.outline.require_min_time = parseInt(content.attributes.minTime);
                        }
                        //

                        cb();

                    },
                    (cb) => {
                        http.get('app/components/' + this.outline.component_id).then(response => {
                            this.component = response.data;
                            cb();
                        }).catch(err => {
                            console.log(err);
                            cb(err);
                        });
                    }
                ], (err) => {
                    if (err) console.log(err);

                    // if (!this.enrollment.completed_at) {
                        this.startTimer();
                        this.sendPing();
                    // }

                    this.loading = false;
                });
            },

            saveData: function(payload) {
                payload.enrollment_id = parseInt(this.enrollmentId);
                http.post('/app/enrollments/save', payload, {force: true}).catch(err => {
                    window.alert('There was an issue saving your data. If this problem persists please contact us.');
                });
            },

            startTimer: function() {
                console.log('Timer: starting');
                this.timer = setInterval(() => {
                    // if (!this.isAppIdle) {
                    this.time++;
                    if (this.time % 60 === 0) this.sendPing();
                    // } else {
                    //     this.timeout--;
                    //     this.timeout = Math.max(0, this.timeout);
                    //     if (this.timeout === 0) {
                    //         console.log('timeout');
                    //         this.$router.push({name: 'enrollments'});
                    //     }
                    // }
                }, 1000);
            },

            sendPing: function() {
                let payload = {
                    session_id: this.uuid,
                    time: this.time,
                    component_id: this.component.id,
                    course_id: this.enrollment.course_id,
                    enrollment_id: this.enrollment.id,
                    type: 'course_outline',
                    type_id: this.outline.id
                };

                http.post('/app/enrollments/ping', payload, {force: true}).then(response => {

                }).catch(err => {

                });
            },

            completeComponent: function() {
                if (!this.enrollment.course.disable_timer && this.outline.require_min_time && Math.floor(this.time / 60 + this.outline.time <= this.outline.require_min_time)) {
                    this.$buefy.toast.open({
                        message: '<i class="fas fa-timer mr-2"></i>You have not completed the required time for this lesson.<br>Please review the content.',
                        type: 'is-danger',
                        duration: 7000,
                        position: 'is-bottom'
                    });
                } else {
                    let payload = {
                        component_id: this.component.id,
                        enrollment_id: this.enrollment.id,
                        type: 'course_outline',  //??
                        type_id: this.outline.id
                    };

                    ///

                    http.post('/app/enrollments/progress', payload, {force: true}).then(response => {
                        this.$emit('update');

                        if (this.outline.nextSectionId) {
                            this.$router.push({name: 'overview', params: {enrollmentId: this.enrollmentId, sectionId: this.outline.nextSectionId}});
                        } else if (this.outline.nextOutlineId) {
                            this.$router.push({name: 'component', params: {enrollmentId: this.enrollmentId, outlineId: this.outline.nextOutlineId}});
                        } else {
                            console.log('Coursework complete');
                            this.$router.push({name: 'course', params: {enrollmentId: this.enrollmentId}});
                        }
                    }).catch(err => {
                        window.alert('There was an issue completing the course content. If this problem persists please contact us.');
                    });
                }
            },
            goToOutline: function(id) {
                this.prevOutlineId = null;
                this.nextOutlineId = null;
                this.$router.push({name: 'component', params: {enrollmentId: this.enrollmentId, outlineId: id}});
            }
        },
        watch: {
            'outlineId': function() {
                this.loadByOutline();
            }
        },
        mounted: function() {
            this.loadByOutline();
        },
        destroyed: function() {
            if (this.timer) clearInterval(this.timer);
        },
        onIdle() {
            console.log('IDLE');
            this.timeout = 60;
        },
        onActive() {
            console.log('ACTIVE');
            this.sendPing();
        }
    };
</script>

<style lang="scss" scoped>
    .content-frame {
        position: absolute;
        top: 105px;
        left: 5rem;
        right: 4rem;
        bottom: 7rem;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.3);
        padding: 2rem 2rem 10rem;

        overflow-x: hidden;
        overflow-y: scroll;
    }

</style>
